/* eslint-disable max-len */
import { useState } from 'react';
import { ProductCategoryPageProps } from '../product-category';
import { W3PurchaseFlowForm } from './purchase-flow-form';
import { PurchaseFlowIconRenderer } from './purchase-flow-icon';

export const useW3PurchaseFlow = (props: ProductCategoryPageProps) => {
  const [activeFormIdx, setActiveFormIdx] = useState(0);

  const IconRenderer = () => {
    return (
      <PurchaseFlowIconRenderer purchaseFlowData={props} activeForm={activeFormIdx} setActiveForm={setActiveFormIdx} />
    );
  };

  const FormRenderer = () => {
    return (
      <W3PurchaseFlowForm
        productCategorySlug={props.productCategorySlug}
        purchaseFlowForm={props.purchaseFlowForms[activeFormIdx]}
      />
    );
  };

  return { IconRenderer, FormRenderer };
};
